import { DraftingCompass, TrendingUp, LifeBuoy } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  {
    icon: DraftingCompass,
    title: "Custom-Built",
    text: "Solutions designed around your exact business requirements.",
  },
  {
    icon: TrendingUp,
    title: "Scalable",
    text: "Technology architecture built to grow with your business.",
  },
  {
    icon: LifeBuoy,
    title: "Long-Term Support",
    text: "Continuous technical support, maintenance and improvements.",
  },
];

export const About = () => (
  <section id="about" className="relative bg-mist py-24 sm:py-32" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <Reveal>
          <Eyebrow>About RCS</Eyebrow>
          <h2 className="mt-5 font-jakarta text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl" data-testid="about-heading">
            Technology Built Around<br className="hidden sm:block" /> Your Business.
          </h2>
          <div className="mt-8 hidden lg:block">
            <div className="relative overflow-hidden rounded-xl border border-slate-200 bg-white p-6">
              <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-400">RCS · Operating principle</span>
              <p className="mt-3 font-jakarta text-xl font-semibold leading-snug text-navy">
                "RCS doesn't just build websites. RCS builds digital products around your business."
              </p>
              <div className="mt-5 h-px w-full bg-gradient-to-r from-gold via-magenta/60 to-transparent" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="space-y-5 font-inter text-[15px] leading-relaxed text-slate-600 sm:text-base" data-testid="about-content">
            <p>
              <strong className="font-semibold text-navy">REBHAS Consultancy Services (RCS)</strong> is a digital
              technology and consulting company focused on building practical, scalable and customized digital solutions.
            </p>
            <p>
              We work with businesses, startups, schools and organizations to design, develop and improve digital
              products that solve real business problems.
            </p>
            <p>
              From a professional website to a complete SaaS platform, ERP system or mobile application, RCS combines
              technology, strategy and user-focused design to deliver solutions tailored to each client's requirements.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {PILLARS.map((p, i) => (
              <Reveal key={p.title} delay={0.1 + i * 0.1}>
                <div
                  className="group h-full rounded-xl border border-slate-200 bg-white p-5 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-gold/50 hover:shadow-[0_20px_40px_-20px_rgba(204,134,13,0.25)]"
                  data-testid={`about-pillar-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold-pale text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-white">
                    <p.icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-4 font-jakarta text-[15px] font-bold text-navy">{p.title}</h3>
                  <p className="mt-1.5 font-inter text-[13px] leading-relaxed text-slate-500">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
